import { render, staticRenderFns } from "./Detail-Request-Po.vue?vue&type=template&id=65e1166a"
import script from "./Detail-Request-Po.vue?vue&type=script&lang=js"
export * from "./Detail-Request-Po.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports